import { Box, VStack } from '@chakra-ui/react';
import { useTriggerForm } from '../useTriggerForm.js';
import WebhookMethodInput from './WebhookMethodInput';
import WebhookUriInput from './WebhookUriInput';
import WebhookHeadersSection from './WebhookHeadersSection';
import FieldsSelector from './FieldsSelector';
import WebhookBodyInput from './WebhookBodyInput';

const TriggerWebhookAction = ({
    darkMode,
    fields,
    cursorPosition,
    setCursorPosition,
    errors,
    touched,
    actionHeaders,
    updateActionHeaders,
}) => {
    // Use context instead of Redux
    const { formData } = useTriggerForm();

    // Only show webhook action fields when WebHook is selected
    if (formData?.action?.actionType !== 'WebHook') return null;

    return (
        <VStack
            spacing={8}
            align="stretch"
            minHeight="fit-content"
            height="auto"
            flex="1">
            <Box width="100%" minHeight="fit-content" height="auto">
                <WebhookMethodInput
                    darkMode={darkMode}
                    errors={errors}
                    touched={touched}
                />
            </Box>

            <WebhookUriInput
                darkMode={darkMode}
                setCursorPosition={setCursorPosition}
                errors={errors}
                touched={touched}
            />

            <WebhookHeadersSection
                darkMode={darkMode}
                setCursorPosition={setCursorPosition}
                actionHeaders={actionHeaders}
                updateActionHeaders={updateActionHeaders}
            />

            <FieldsSelector
                darkMode={darkMode}
                fields={fields}
                cursorPosition={cursorPosition}
                setCursorPosition={setCursorPosition}
            />

            <WebhookBodyInput
                darkMode={darkMode}
                fields={fields}
                setCursorPosition={setCursorPosition}
                errors={errors}
                touched={touched}
            />
        </VStack>
    );
};

export default TriggerWebhookAction;
